export enum NormalError {
  USER_ALREADY_EXIST = "The email already exists in system.",
  DuplicateSettingCompany = "Company already exists in the system.",
  DuplicateRole = "The position already exists in system.",
}
